import styled from 'styled-components'

const H3 = styled.h3`
  color: #000;
  font-size: 16px;
  font-weight: bold;
`

export default H3
